import { useParams } from "react-router-dom";
import { useGetBookQuery } from "../../features/api/apiSlice";
import Error from "../ui/Error";
import EditForm from "./Form";
import Form from "./Form";

export default function EditBook() {
    const { bookId } = useParams();
    const { data, isLoading, isError } = useGetBookQuery(bookId);

    let content = null;

    if (isLoading) {
        content = <div>Loading...</div>;
    }else if ( isError) {
        content = <Error message="There was an error!" />;
    }else if (data?.id) {
        content = <EditForm book={data} />;
    }

    return (
        <main className="py-6 2xl:px-6">
            <div className="container">
                <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                    <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
                    {content}
                </div>
            </div>
        </main>
    );
}
